import React, { Component } from "react";
import YouTube from "react-youtube";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import "./Sermons.scss";
import Page from "../Page/Page";
import { SermonsService } from "../../services/SermonsService";
import moment from "moment";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import Fab from "@material-ui/core/Fab";
import UpButton from "../ScrollToTop/Button";
import { Link } from "react-router-dom";
import { FacebookProvider, EmbeddedVideo } from "react-facebook";

class Sermons extends Component {
  sermonsService = new SermonsService();

  constructor(props) {
    super(props);
    this.state = {
      sermons: [],
      book: "",
      service: "",
      preacher: "",
      startDate: null,
      endDate: null,
      keywords: "",
      latestSermon: { youtube_video_embed_html: "" },
      filters: {
        books: [],
        services: [],
        preachers: []
      },
      showScrollButton: false
    };
  }

  async componentDidMount() {
    const [sermons, filters] = await Promise.all([
      this.sermonsService.getAllSermons(),
      this.sermonsService.getSermonFilters()
    ]);

    const latestSermon = sermons[0];
    latestSermon.facebook = (
      <FacebookProvider appId={`${process.env.FACEBOOK_APP_ID}`}>
        <EmbeddedVideo
          href={"https://www.facebook.com/ReformedBaptistChurch/videos/" + latestSermon.facebook_video_code}
        />
      </FacebookProvider>
    );
    latestSermon.youtube = <YouTube videoId={latestSermon.youtube_video_code} opts={{ playerVars: { rel: 0 } }} />;
    latestSermon.audio = <audio src={latestSermon.audio_file_src} controls />;

    this.setState({ sermons, filters, latestSermon });
    window.addEventListener("scroll", this.handleScroll.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll.bind(this));
  }

  handleScroll(event) {
    this.setState({ showScrollButton: window.scrollY > 1300 });
  }

  filterSermons = async () => {
    const query = {};
    let sermons;

    if (this.state.book) {
      query.book = this.state.book;
    }

    if (this.state.service) {
      query.service = this.state.service;
    }

    if (this.state.preacher) {
      query.preacher = this.state.preacher;
    }

    if (this.state.startDate) {
      query.startDate = moment(this.state.startDate).format("YYYY-MM-DD");
    }

    if (this.state.endDate) {
      query.endDate = moment(this.state.endDate).format("YYYY-MM-DD");
    }

    if (
      !this.state.book &&
      !this.state.service &&
      !this.state.preacher &&
      !this.state.startDate &&
      !this.state.endDate
    ) {
      sermons = await this.sermonsService.getAllSermons(query);
    } else {
      sermons = await this.sermonsService.getFilteredSermons(query);
    }

    this.setState({ sermons });
  };

  handleSermonClicked = (sermon) => {
    sermon.facebook = (
      <FacebookProvider appId={`${process.env.FACEBOOK_APP_ID}`}>
        <EmbeddedVideo href={"https://www.facebook.com/ReformedBaptistChurch/videos/" + sermon.facebook_video_code} />
      </FacebookProvider>
    );
    sermon.youtube = <YouTube videoId={sermon.youtube_video_code} opts={{ playerVars: { rel: 0 } }} />;
    sermon.audio = <audio src={sermon.audio_file_src} controls autoPlay />;
    this.setState({ latestSermon: sermon });
    this.sermonsService.postSermonView(sermon.id);
  };

  content() {
    const books = this.state.filters.books.map((book, index) => (
      <MenuItem value={book.id} key={index}>
        {book.name}
      </MenuItem>
    ));

    const services = this.state.filters.services.map((service, index) => (
      <MenuItem value={service.id} key={index}>
        {service.name}
      </MenuItem>
    ));

    const preachers = this.state.filters.preachers.map((preacher, index) => (
      <MenuItem value={preacher.id} key={index}>
        {preacher.name}
      </MenuItem>
    ));

    const sermons = this.state.sermons.map((sermon, index) => (
      <tr key={index}>
        <td className="first">{moment(sermon.date).format("MM/DD/YYYY")}</td>
        <td className="second">{sermon.service_name}</td>
        <td className="third">
          <Link to={`/preacher/${sermon.preacher_slug}`}>{sermon.preacher}</Link>
        </td>
        <td className="fourth">{sermon.bible_passage}</td>
        <td className="fifth">
          <a href={`/sermons/${sermon.permalink}/`}>{sermon.title}</a>
        </td>
        <td className="sixth">
          <a href="#latest-sermon" onClick={(ev) => this.handleSermonClicked(sermon)}>
            <Fab color="primary">
              <PlayArrowIcon fontSize="large"></PlayArrowIcon>
            </Fab>
          </a>
        </td>
      </tr>
    ));

    return (
      <div className="sermons">
        <a name="latest-sermon"></a>
        <div id="latest-sermon" className="outer-container">
          <div className="background-filter">
            <div className="container latest-sermon-container">
              <div className="row">
                {this.state.latestSermon.title && (
                  <div className="col-sm">
                    <h2>{`"${this.state.latestSermon.title}"`}</h2>
                    <h3>{this.state.latestSermon.preacher}</h3>
                    <h5>{moment(this.state.latestSermon.date).format("MMMM Do, YYYY")}</h5>
                    {this.state.latestSermon.bible_passage && (
                      <h5>
                        Scripture: <i>{this.state.latestSermon.bible_passage}</i>
                      </h5>
                    )}

                    {(this.state.latestSermon.youtube_video_code || this.state.latestSermon.facebook_video_code) && (
                      <div className="video-player-container">
                        <div className="video-container">
                          {this.state.latestSermon.youtube_video_code && (
                            <div className="video-responsive">{this.state.latestSermon.youtube}</div>
                          )}
                          {!this.state.latestSermon.youtube_video_code &&
                            this.state.latestSermon.facebook_video_code && (
                              <div className="video-responsive">{this.state.latestSermon.facebook}</div>
                            )}
                        </div>
                      </div>
                    )}

                    {this.state.latestSermon.audio_file_src && this.state.latestSermon.audio}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div id="sermons-container" className="container sermons-container">
          <div className="filters">
            <div className="row">
              <div className="col-sm">
                <FormControl variant="outlined" style={{ width: "100%" }}>
                  <InputLabel id="book">Book</InputLabel>
                  <Select
                    labelId="book"
                    id="book-select"
                    value={this.state.book}
                    onChange={(event) => this.setState({ book: event.target.value })}
                    labelWidth={36}
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    {books}
                  </Select>
                </FormControl>
              </div>
              <div className="col-sm">
                <FormControl variant="outlined" style={{ width: "100%" }}>
                  <InputLabel id="service">Service</InputLabel>
                  <Select
                    labelId="service"
                    id="service-select"
                    value={this.state.service}
                    onChange={(event) => this.setState({ service: event.target.value })}
                    labelWidth={53}
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    {services}
                  </Select>
                </FormControl>
              </div>
              <div className="col-sm">
                <FormControl variant="outlined" style={{ width: "100%" }}>
                  <InputLabel id="preacher">Preacher</InputLabel>
                  <Select
                    labelId="preacher"
                    id="preacher-select"
                    value={this.state.preacher}
                    onChange={(event) => this.setState({ preacher: event.target.value })}
                    labelWidth={63}
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    {preachers}
                  </Select>
                </FormControl>
              </div>
            </div>
            <div className="row">
              <div className="col-sm">
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <Grid container justify="space-around">
                    <KeyboardDatePicker
                      clearable
                      disableToolbar
                      margin="normal"
                      id="start-date-picker-dialog"
                      label="Start Date"
                      value={this.state.startDate}
                      placeholder={moment(new Date()).format("MM/DD/YYYY")}
                      onChange={(date) => this.setState({ startDate: date })}
                      format="MM/dd/yyyy"
                      style={{ width: "100%" }}
                    />
                  </Grid>
                </MuiPickersUtilsProvider>
              </div>
              <div className="col-sm">
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <Grid container justify="space-around">
                    <KeyboardDatePicker
                      clearable
                      disableToolbar
                      margin="normal"
                      id="end-date-picker-dialog"
                      label="End Date"
                      value={this.state.endDate}
                      placeholder={moment(new Date()).format("MM/DD/YYYY")}
                      onChange={(date) => this.setState({ endDate: date })}
                      format="MM/dd/yyyy"
                      style={{ width: "100%" }}
                    />
                  </Grid>
                </MuiPickersUtilsProvider>
              </div>
              <div className="col-sm">
                <Button variant="contained" size="large" color="primary" onClick={this.filterSermons}>
                  Update
                </Button>
              </div>
            </div>
          </div>
          <table id="sermons-list">
            <tbody>
              <tr>
                <td className="first">Date</td>
                <td className="second">Service</td>
                <td className="third">Speaker</td>
                <td className="fourth">Scripture</td>
                <td className="fifth">Title</td>
                <td className="sixth">Listen</td>
              </tr>
              {sermons}
            </tbody>
          </table>
        </div>
        <div className={this.state.showScrollButton ? "visible" : "hidden"}>
          <UpButton link="#sermons-container" />
        </div>
      </div>
    );
  }

  render() {
    return <Page permalink="sermons" header="Sermons" content={this.content()} />;
  }
}

export default Sermons;
